export const isInIframe = () => {
	try {
		return window.self !== window.top || window.top !== window.parent;
	} catch (e) {
		return true;
	}
};
